import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { EnvironmentTax } from "@/Common/Helpers/EnvironmentTax";
import { JSXHelper } from "@/Common/Helpers/JSXHelper";
import { EnumMyleLoginPermission } from "@/Common/Models/EnumMyleLoginPermission";
import { SitesModel } from "@/Common/Models/Sites/SitesModel";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BillingServiceAutocomplete } from "@/Patient/Components/History/BillingServiceAutocomplete";
import { IBillableService } from "@/Patient/Models/UI/History/IBillableService";

import "./BillableService.css";

interface IBillableServiceProps {
    model: IBillableService;
    costCenterId?: string;

    ClearOp: number; // LocalPatientOperations.History.PrivateBill_ClearSelection
    SelectService: number; // LocalPatientOperations.History.PrivateBill_SelectBillableService
    PriceChange: number; // LocalPatientOperations.History.PrivateBill_OnPriceChange
    QuantityChanged: number; // LocalPatientOperations.History.PrivateBill_OnQuantityChange
    ChangeGST: number; // LocalPatientOperations.History.PrivateBill_ChangeHasGST
    ChangeQST: number; // LocalPatientOperations.History.PrivateBill_ChangeHasQST
    ChangeHST: number; // LocalPatientOperations.History.PrivateBill_ChangeHasHST
    ChangeGenericTax: number; // LocalPatientOperations.History.PrivateBill_ChangeHasGenericTax
    RemoveService: number; // LocalPatientOperations.History.PrivateBill_RemoveService

    selectedSite: SitesModel;
}

class BillableServiceState {
    public isPriceEditSelected: boolean;
    public newPrice: number;

    constructor(params: Partial<BillableServiceState>) {
        Object.assign(this, params);
    }
}

class BillableService extends BaseReactComponent<IBillableServiceProps, BillableServiceState> {
    constructor(props: IBillableServiceProps) {
        super(props);

        this.state = new BillableServiceState({
            newPrice: props.model.get("Price"),
            isPriceEditSelected: false
        });
    }

    public render(): JSX.Element {
        let hasCostPermission = sessionStore.hasPermission(EnumMyleLoginPermission.BillingCostPermission);

        return (
            <div className="flex-container">
                {this.props.model.get("IsFromServiceList") === false && (
                    <div className="bill-service-component flex-container" style={{ width: "100%", justifyContent: "flex-start" }}>
                        <div className="multiplier-column fcol">
                            <input
                                type="number"
                                className="form-control myle"
                                onChange={this.OnChangeQuantity.bind(this, this.props.model.get("Id"))}
                                value={String(this.props.model.get("Qty"))}
                                data-cy="billService-quantity"
                            />
                        </div>
                        <div className="label-column fcol">
                            <strong> x</strong>
                        </div>
                        <div className="autocomplete-column fcol" data-cy="billService-service">
                            <BillingServiceAutocomplete
                                clearOp={this.props.ClearOp}
                                disabled={false}
                                closeDropDownAfterSelection={true}
                                componentId={this.props.model.get("Id")}
                                focusOnLoad={false}
                                selectionOp={this.props.SelectService}
                                selectedItem={this.props.model.get("SelectedService")}
                                costCenterId={this.props.costCenterId ? this.props.costCenterId : ""}
                                removeServiceOp={this.props.RemoveService}
                            />
                        </div>

                        {(hasCostPermission || sessionStore.getCurrentEmployee().isActiveSiteMexico() === false) && (
                            <div className="flex-container currency-colum fcol">
                                <input
                                    type="number"
                                    className="form-control myle"
                                    onChange={this.onPriceChange.bind(this, this.props.model.get("Id"))}
                                    value={String(this.props.model.get("Price"))}
                                    data-cy="billService-price"
                                />
                            </div>
                        )}

                        {this.renderCheckboxes(hasCostPermission, this.props.model.get("IsFromServiceList"))}

                    </div>
                )}
                {this.props.model.get("IsFromServiceList") === true && (
                    <div className="bill-service-component flex-container" style={{ width: "100%", justifyContent: "flex-start" }}>
                        <div className="multiplier-column fcol">
                            <input type="number" className="form-control myle" onChange={this.OnChangeQuantity.bind(this, this.props.model.get("Id"))} value={String(this.props.model.get("Qty"))} />
                        </div>
                        <div className="label-column fcol">
                            <strong> x</strong>
                        </div>
                        {sessionStore.userLanguageCode === "fr" && (
                            <div className="autocomplete-column fcol" style={{ paddingTop: "10px" }}>
                                <span>{JSXHelper.BreakStringIntoParagraphs(this.props.model.get("NameFr"))}</span>
                            </div>
                        )}
                        {sessionStore.userLanguageCode === "en" && (
                            <div className="autocomplete-column fcol" style={{ paddingTop: "10px" }}>
                                <span>{JSXHelper.BreakStringIntoParagraphs(this.props.model.get("NameEn"))}</span>
                            </div>
                        )}
                        {sessionStore.userLanguageCode === "es-MX" && (
                            <div className="autocomplete-column fcol" style={{ paddingTop: "10px" }}>
                                <span>{JSXHelper.BreakStringIntoParagraphs(this.props.model.get("NameEs"))}</span>
                            </div>
                        )}
                        {(hasCostPermission || sessionStore.getCurrentEmployee().isActiveSiteMexico() === false) && (
                            <div className="flex-container currency-colum price-col">

                                {(this.state.isPriceEditSelected && (
                                    <input
                                        type="number"
                                        value={this.state.newPrice}
                                        onBlur={e => this.priceTextBoxOnBlur(e)}
                                        onChange={e => this.priceOnChange(e)}
                                        className="form-control myle"
                                        autoFocus
                                    />
                                )
                                )}
                                {(!this.state.isPriceEditSelected) && (
                                    <div className="flex-container currency-colum price-col">
                                        <strong>$ {String((+this.props.model.get("Price")).toFixed(2))}</strong>
                                        <a className="edit-icon" onClick={() => this.onEditPriceClick()}>
                                            <i className="fa fa-pencil" />
                                        </a>
                                    </div>
                                )}
                            </div>
                        )}

                        {this.renderCheckboxes(hasCostPermission, this.props.model.get("IsFromServiceList"))}

                    </div>
                )}
                <div className="delete-column fcol flex-container" style={{ justifyContent: "flex-end", width: "390px", paddingTop: "10px" }}>
                    <div className="fl-x-2" style={{ width: "100%" }}>
                        <span style={{ width: "201px" }} />
                        <strong> {"$ " + String((this.props.model.get("Price") * this.props.model.get("Qty")).toFixed(2))}</strong>
                    </div>
                    {this.props.model.get("SelectedService") != null &&
                        <span onClick={this.RemoveBillableService.bind(this, this.props.model.get("Id"))} className="glyphicon glyphicon-remove red-text pointer" />
                    }
                </div>
            </div>
        );
    }

    private onEditPriceClick(): void {
        this.mutateState(s => {
            s.newPrice = this.props.model.get("Price");
            s.isPriceEditSelected = true;
        });
    }

    private priceTextBoxOnBlur(e: React.FocusEvent<HTMLInputElement>): void {
        this.onPriceChange(this.props.model.get("Id"), e);
        this.mutateState(s => s.isPriceEditSelected = false);
    }

    public onPriceChange(id: string, e: React.FocusEvent<HTMLInputElement>): void {
        var operation = new LocalEvent(this.props.PriceChange);
        operation.AddItem("id", id);
        operation.AddItem("value", e.target.value);
        LocalEventDispatcher.dispatch(operation);
    }

    public OnChangeQuantity(id: string, e: React.ChangeEvent<HTMLInputElement>): void {
        var operation = new LocalEvent(this.props.QuantityChanged);
        operation.AddItem("id", id);
        operation.AddItem("value", e.target.value);
        LocalEventDispatcher.dispatch(operation);
    }

    public ChangeHasGST(id: string): void {
        var operation = new LocalEvent(this.props.ChangeGST);
        operation.AddItem("id", id);
        LocalEventDispatcher.dispatch(operation);
    }

    public ChangeHasQST(id: string): void {
        var operation = new LocalEvent(this.props.ChangeQST);
        operation.AddItem("id", id);
        LocalEventDispatcher.dispatch(operation);
    }

    public ChangeHasHST(id: string): void {
        sessionStore.dispatch(this.props.ChangeHST, { id });
    }

    private changeHasGenericTax(id: string): void {
        sessionStore.dispatch(this.props.ChangeGenericTax, { id });
    }

    public RemoveBillableService(id: string): void {
        var operation = new LocalEvent(this.props.RemoveService);
        operation.AddItem("id", id);
        LocalEventDispatcher.dispatch(operation);
    }

    private renderCheckboxes(hasCostPermission: boolean, isFromServiceList: boolean): JSX.Element {
        if (!hasCostPermission && sessionStore.getCurrentEmployee().isActiveSiteMexico())
            return null;

        return (
            <div style={{ display: "inline-flex" }}>
                {this.props.selectedSite.isHst() && this.renderHstCheckbox(isFromServiceList)}
                {this.props.selectedSite.isGst() && this.renderGstCheckbox(isFromServiceList)}
                {this.props.selectedSite.isPstOrQst() && this.renderQstCheckbox(isFromServiceList)}
                {!this.props.selectedSite.isCanadaSite() && this.renderGenericTaxCheckbox(isFromServiceList)}
            </div>
        );
    }

    private renderGstCheckbox(disabled: boolean): JSX.Element {
        return (
            <div className="tax-column fcol">
                <div className="checkbox">
                    <label>
                        <input type="checkbox" disabled={disabled} onClick={() => this.ChangeHasGST(this.props.model.get("Id"))} checked={this.props.model.get("HasGST")} />
                        {cacheStore.GetString("GstMLabel")}
                    </label>
                </div>
            </div>
        );
    }

    private renderQstCheckbox(disabled: boolean): JSX.Element {
        return (
            <div className="tax-column fcol">
                <div className="checkbox">
                    <label>
                        <input type="checkbox" disabled={disabled} onClick={() => this.ChangeHasQST(this.props.model.get("Id"))} checked={this.props.model.get("HasQST")} />
                        {this.props.selectedSite?.getPstOrQstLabel() ?? EnvironmentTax.getPstOrQstLabel()}
                    </label>
                </div>
            </div>
        );
    }

    private renderHstCheckbox(disabled: boolean): JSX.Element {
        return (
            <div className="tax-column fcol">
                <div className="checkbox">
                    <label>
                        <input type="checkbox" disabled={disabled} onClick={() => this.ChangeHasHST(this.props.model.get("Id"))} checked={this.props.model.get("HasHST")} />
                        {cacheStore.GetString("HstMLabel")}
                    </label>
                </div>
            </div>
        );
    }

    private renderGenericTaxCheckbox(disabled: boolean): JSX.Element {
        return (
            <div className="tax-column fcol">
                <div className="checkbox">
                    <label>
                        <input type="checkbox" disabled={disabled} onClick={() => this.changeHasGenericTax(this.props.model.get("Id"))} checked={this.props.model.get("HasGenericTax")} />
                        {cacheStore.GetString("TaxLabel")}
                    </label>
                </div>
            </div>
        );
    }

    private priceOnChange(e: React.ChangeEvent<HTMLInputElement>): void {
        const { value } = e.target;
        if (value.startsWith("0")) {
            e.target.value = value.replace("0", "");
        }
        this.mutateState(s => s.newPrice = parseFloat(e.target.value));
    }
}

export { BillableService };
